/* Ezoko – vertical video cards: silent loop while visible, tap to open full screen with sound. */
(function () {
  if (window.__ezVideo) return; window.__ezVideo = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && !reduce) { if (v.preload === 'none') v.preload = 'metadata'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.5 }) : null;

  function initCards(root) {
    (root || document).querySelectorAll('[data-ezv-loop]:not([data-ezv-ok])').forEach(function (v) {
      v.setAttribute('data-ezv-ok', '');
      v.muted = true;
      if (io) io.observe(v);
    });
  }

  var dlg, dv, lastBtn;
  function ensureDialog() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'ezv-dlg';
    dlg.innerHTML = '<div class="ezv-dlg__box"><video class="ezv-dlg__v" controls playsinline></video>' +
      '<button type="button" class="ezv-dlg__x" aria-label="Close">&times;</button></div>';
    document.body.appendChild(dlg);
    dv = dlg.querySelector('video');
    dlg.querySelector('.ezv-dlg__x').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { dv.pause(); dv.removeAttribute('src'); dv.load(); document.documentElement.classList.remove('ezv-lock'); if (lastBtn) lastBtn.focus(); });
  }
  function close() { if (dlg && dlg.open) dlg.close(); }
  function open(btn) {
    ensureDialog();
    lastBtn = btn;
    dlg.querySelector('.ezv-dlg__x').setAttribute('aria-label', btn.getAttribute('data-close') || 'Close');
    dlg.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Video');
    dv.poster = btn.getAttribute('data-poster') || '';
    dv.src = btn.getAttribute('data-src');
    document.documentElement.classList.add('ezv-lock');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    dv.muted = false;
    var p = dv.play(); if (p && p.catch) p.catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ezv-open]');
    if (!b) return;
    e.preventDefault();
    open(b);
  });

  initCards();
  document.addEventListener('shopify:section:load', function (e) { initCards(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCards(); });
})();
